/**
 * Разбор и упорядочивание рангов League of Legends для группировки списков.
 *
 * Ранг приходит строкой вида «EMERALD 2», «MASTER», «UNRANKED» — дивизион вшит
 * в ту же строку, отдельного поля у него нет.
 */

/** «UNRANKED», пустая строка и прочерк одинаково означают «ранга нет». */
export function hasRank(rank?: string | null): boolean {
  const r = (rank ?? "").trim().toLowerCase();
  return r !== "" && r !== "unranked" && r !== "—" && r !== "-";
}

/** Тир без дивизиона: «EMERALD 2» и «EMERALD 4» — одна группа. */
export function rankTierName(rank?: string | null): string {
  const first = (rank ?? "").trim().split(/\s+/)[0] ?? "";
  return first ? first.toUpperCase() : "UNRANKED";
}

/** Тиры от сильного к слабому. */
export const RANK_ORDER = [
  "CHALLENGER",
  "GRANDMASTER",
  "MASTER",
  "DIAMOND",
  "EMERALD",
  "PLATINUM",
  "GOLD",
  "SILVER",
  "BRONZE",
  "IRON",
] as const;

/**
 * Вес тира для сортировки: меньше — сильнее. Незнакомый тир и «UNRANKED»
 * уходят в самый низ, а не наверх: иначе игроки без ранга возглавляли бы список.
 */
export function rankWeight(tier: string): number {
  const i = RANK_ORDER.indexOf(tier as (typeof RANK_ORDER)[number]);
  return i < 0 ? RANK_ORDER.length : i;
}

/**
 * Ранг для показа: текущий, а если его нет — тот, по которому игрока оценивали.
 *
 * У части игроков нет текущего ранга на RU, но цена посчитана по истории op.gg.
 * Показывать им «UNRANKED», когда оценивали по мастеру, — вводить в заблуждение
 * и ронять их в чужую группу.
 */
export function displayRank(
  currentRank?: string | null,
  evaluatedRank?: string | null,
): string | undefined {
  if (hasRank(currentRank)) return currentRank ?? undefined;
  if (hasRank(evaluatedRank)) return evaluatedRank ?? undefined;
  return currentRank ?? undefined;
}
